(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/column-video/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_layouts/column-video/assets/javascripts/render-component.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const isServer = typeof exports === 'object';

async function renderComponent(model, widgetInfo, position, req, res) {
  var _model$contentType, _svs;
  let hbsCompiled;
  let format;
  let isAdmin;
  let getCallToAction;
  let youTubeVideoComponent;
  let solidTangoVideoComponent;
  if (isServer) {
    const trinidad = require('@svenskaspelab/trinidad-core').core;
    const hbs = global.internalInstances.get('hbs');
    hbsCompiled = hbs.cache['components-banner_layouts-column_video-column_video'];
    format = trinidad.components.require('utils', 'format').api;
    isAdmin = req.userSession.hasRole(req.userSession.roles.INTERNAL);
    getCallToAction = trinidad.components.require('banner_common', 'banner-helpers').getCallToAction;
    youTubeVideoComponent = trinidad.components.require('components', 'youtube-video');
    solidTangoVideoComponent = trinidad.components.require('components', 'video-player');
  } else {
    hbsCompiled = svs.banner_layouts.column_video.templates.column_video;
    format = svs.utils.format;
    isAdmin = svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL);
    getCallToAction = svs.banner_common.banner_helpers.getCallToAction;
    youTubeVideoComponent = svs.components.youtube_video.utils;
    solidTangoVideoComponent = svs.components.video_player.contentLoader;
  }
  const getVideoModel = video => {
    if (video === undefined) {
      return '';
    }
    let model;
    if (video.type === 'youtube') {
      youTubeVideoComponent.loadVideo({
        api: false,
        type: video.type,
        videoId: video.id || video.videoId,
        width: 1280,
        height: 560,
        title: video.title ? video.title : "video-".concat(video.id || video.videoId),
        duration: video === null || video === void 0 ? void 0 : video.duration,
        thumbnail: video === null || video === void 0 ? void 0 : video.thumbnail,
        publishedAt: video === null || video === void 0 ? void 0 : video.publishedAt
      }, (err, videoModel) => {
        if (err) {
          throw new Error(err);
        } else {
          model = videoModel;
        }
      });
      return model;
    }
    solidTangoVideoComponent.loadVideo({
      api: false,
      type: video.type || 'solidtango',
      videoId: video.id || video.videoMediaId,
      title: video.title ? video.title : 'video',
      width: 1280,
      height: 560,
      duration: video === null || video === void 0 ? void 0 : video.duration,
      thumbnail: video === null || video === void 0 ? void 0 : video.thumbnail,
      publishedAt: video === null || video === void 0 ? void 0 : video.publishedAt
    }, (err, videoModel) => {
      if (err) {
        throw new Error(err);
      } else {
        model = videoModel;
      }
    });
    return model;
  };
  const callToActions = model.callToActions,
    bannerId = model.id,
    layoutConfig = model.layoutConfig,
    layoutType = model.layoutType,
    title = model.title,
    videos = model.videos;
  const actionViewConfig = {
    transparent: true,
    block: false
  };
  const callToAction = (callToActions === null || callToActions === void 0 ? void 0 : callToActions[0]) && getCallToAction(callToActions === null || callToActions === void 0 ? void 0 : callToActions[0], actionViewConfig);
  const contentType = (model === null || model === void 0 || (_model$contentType = model.contentType) === null || _model$contentType === void 0 ? void 0 : _model$contentType.split(':').pop()) || 'banner';
  const isFullWidth = false;
  const trackingStringTitle = format.safeString(title) || title;
  const trackingString = "".concat(widgetInfo.widgetType, "/").concat(widgetInfo.trackingId, "/").concat(position, "/").concat(layoutType, "/").concat(trackingStringTitle);
  const video = videos !== null && videos !== void 0 && videos[0] ? getVideoModel(videos[0]) : getVideoModel(videos);
  return hbsCompiled(_objectSpread(_objectSpread({}, layoutConfig), {}, {
    bannerId,
    features: isServer ? res.locals.features : (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.features,
    callToAction,
    contentType,
    isAdmin,
    isFullWidth,
    trackingString,
    video
  })) || '';
}
if (isServer) {
  module.exports = {
    renderComponent
  };
} else {
  svs.banner_layouts.column_video = {
    renderComponent
  };
}

 })(window);